import {
  formatNumberNDecimalPlaces,
  formatSiteTableBytes,
  capitalizeString
} from "../../../utils/format";
import { getTextColor } from "../../../utils/colors";
import { defaultCellValue, routeURLs } from "../../../utils/enums";
import { getCookie } from "../../../serviceWorker";
import { updateCookie } from "../../../utils/common";
import { getVManageMonitorUrl } from "../../../utils/vManageNavigation";
import {
  getCellTemplateWithTooltipAndLink,
  getCellTemplateWithTooltip,
  tViews,
  tCommon
} from "../../../utils/table";
 
export const getTableColumns = (tableId, navigate, reporting, setSelectedSite, openTableSettings) => {
  let tableColumns = [
    {
      prop: "site_name",
      get name() { return tViews('site'); },
      size: 180,
      cellProperties: () => {
        return { role: "cell"};
      },
      cellTemplate: (createElement, props) =>
        getCellTemplateWithTooltipAndLink(navigate, (navigate, model) => { 
            const isUIconvergence = getCookie("cl-analytics");
            const sitesId = model && model.site_id ? model.site_id : '';
  
            if (isUIconvergence) {
              updateCookie("currentSite", sitesId);
              window.location.href = getVManageMonitorUrl("/overview");
            } else {
              setSelectedSite(sitesId);
              navigate(routeURLs.overview);
            } 
          }, createElement, props, tableId)
    },
    {
      prop: "availability",
      get name() { return tViews('siteAvailabilityPercentage'); },
      size: 140,
      cellProperties: ({ model, prop }) => {
        return { style: { color: getTextColor(model[prop], "availability") } };
      }
    },
    {
      prop: "city",
      get name() { return tViews('siteLocation'); },
      size: 120,
      cellProperties: () => {
        return { role: "cell"};
      },
      cellTemplate: (...args) => getCellTemplateWithTooltip(tableId, ...args), 
    },
    {
      prop: "display_usage",
      get name() { return tViews('applicationTableViewUsage'); },
      sortable: true,
      size: 150
    },
    {
      prop: "loss",
      get name() { return tViews('applicationTableViewLoss'); }, 
      size: 150
    },
    {
      prop: "latency",
      get name() { return tViews('latencyInMPS'); },
      size: 170
    },
    {
      prop: "jitter",
      get name() { return tViews('jitterInMS'); },
      size: 150
    },
    {
      prop: "actions",
      name: "Actions",
      hiddenText: "Actions",
      disableToggle: true,
      headerSlot: false,
      pin: "colPinEnd",
      size: 70,
      columnTemplate: (createElement) => {
        return createElement("hbr-icon-button", {
          name: "gear-six-outlined",
          class: "hbr-css__table-cell-align-center gear-icon",
          aria: { label: tCommon('tableSettings') },
          "data-testid": "setting-traffic-logs",
          onClick: (evt) => {
            evt.stopPropagation();
            openTableSettings();
          }
        });
      }
    }
  ];
   if(reporting)tableColumns = tableColumns.filter(col => col.name !== "Actions" && col.prop !== "actions");
  return tableColumns.map(col => ({
    ...col,
    id: col.prop,
    sortable: col.prop !== "actions" ? true : false
  }));
};

const validateAndFormatNumber = (value, decimalPlaces = 1) => {
  if (Number.isFinite(value))
    return formatNumberNDecimalPlaces(value, decimalPlaces);
  return defaultCellValue;
};

export const setSitesData = data => {
  for (const item of data) { 
    item.availability = validateAndFormatNumber(item.availability);
    item.city = capitalizeString(item.city);    
    item.packet_loss = validateAndFormatNumber(item.packet_loss);
    item.latency = validateAndFormatNumber(item.latency);
    item.jitter = validateAndFormatNumber(item.jitter);
    item.usage = formatSiteTableBytes(item.usage); 
  }
  return data;
};
 
